import { useState } from "react";
import { notification } from "antd";
import { ProductUpdate } from "@/types/product";
import { productUpdate } from "@/apis/product";
import { useTranslation } from "react-i18next";
import errorCodes from "@/apis/error";

type Update = (id: string, props: ProductUpdate) => Promise<void>
type IUseProductUpdate = () => [ boolean, { update: Update } ]

const useProductUpdate:IUseProductUpdate = () => {
  const { t } = useTranslation();
  const [ upLoading, setUpLoading] = useState<boolean>(false);

  const update: Update = async (id, props) => {
    setUpLoading(true);
    try {
      await productUpdate(id, props);

      notification.success({ placement: 'top', message: t('product.modifySuccess')})
    } catch (err) {
      notification.error({ placement: 'top', message: t('product.modifyFailed'), description: errorCodes[Number(err)] || err as String });
    } finally {
      setUpLoading(false)
    }
  }

  return [ upLoading, { update }]
}

export default useProductUpdate;